import { TableRow, CircularProgress, Stack, TableCell } from '@mui/material'
import type { FC } from 'react'

interface Props {
  colSpan: number
}

const TableRowLoading: FC<Props> = ({ colSpan }) => (
  <TableRow>
    <TableCell colSpan={colSpan}>
      <Stack direction="column" alignItems="center" paddingTop="20px">
        <span data-testid="table-row-loading">
          <CircularProgress size={20} />
        </span>
      </Stack>
    </TableCell>
  </TableRow>
)

export default TableRowLoading
